import { connect } from 'react-redux';
import {
  setEhawkTalon,
  setFirstName,
  blurFirstName,
  setLastName,
  blurLastName,
  setPhoneNumber,
  blurPhoneNumber,
  setCompanyName,
  blurCompanyName,
  setWebsite,
  blurWebsite,
  setEmail,
  blurEmail,
  setOccupation,
  toggleIsTransactional,
  toggleIsMarketing,
  setEmailVolume,
  setEmployeeCount,
  checkIsFormValid,
  onSave,
  fetchStatus,
  onAdsSave,
  setAdsUser,
} from '../actions';

const mapDispatchToProps = dispatch => ({
  setEhawkTalon: (talon) => {
    dispatch(setEhawkTalon(talon));
  },
  setFirstName: (e, firstName) => {
    dispatch(setFirstName(firstName));
    dispatch(checkIsFormValid());
  },
  blurFirstName: (e, firstName) => {
    dispatch(blurFirstName(firstName));
  },
  setLastName: (e, lastName) => {
    dispatch(setLastName(lastName));
    dispatch(checkIsFormValid());
  },
  blurLastName: (e, lastName) => {
    dispatch(blurLastName(lastName));
  },
  setPhoneNumber: (e, phoneNumber) => {
    dispatch(setPhoneNumber(phoneNumber));
    dispatch(checkIsFormValid());
  },
  blurPhoneNumber: (e, phoneNumber) => {
    dispatch(blurPhoneNumber(phoneNumber));
  },
  setCompanyName: (e, companyName) => {
    dispatch(setCompanyName(companyName));
    dispatch(checkIsFormValid());
  },
  blurCompanyName: (e, companyName) => {
    dispatch(blurCompanyName(companyName));
  },
  setWebsite: (e, website) => {
    dispatch(setWebsite(website));
    dispatch(checkIsFormValid());
  },
  blurWebsite: (e, website) => {
    dispatch(blurWebsite(website));
  },
  setEmail: (e, email) => {
    dispatch(setEmail(email));
    dispatch(checkIsFormValid());
  },
  blurEmail: (e, email) => {
    dispatch(blurEmail(email));
  },
  setOccupation: (event) => {
    dispatch(setOccupation(event.target.value));
    dispatch(checkIsFormValid());
  },
  toggleIsTransactional: () => {
    dispatch(toggleIsTransactional());
    dispatch(checkIsFormValid());
  },
  toggleIsMarketing: () => {
    dispatch(toggleIsMarketing());
    dispatch(checkIsFormValid());
  },
  setEmailVolume: (event) => {
    dispatch(setEmailVolume(event.target.value));
    dispatch(checkIsFormValid());
  },
  setEmployeeCount: (event) => {
    dispatch(setEmployeeCount(event.target.value));
    dispatch(checkIsFormValid());
  },
  onSave: (profileInputs, history) => {
    dispatch(onSave(profileInputs, history));
  },
  fetchStatus: () => {
    dispatch(fetchStatus());
  },
  onAdsSave: (profileInputs, history) => {
    dispatch(onAdsSave(profileInputs, history));
  },
  setAdsUser: (isAdsUser) => {
    dispatch(setAdsUser(isAdsUser));
  },
});

function mapStateToProps({ profileInputs }) {
  return { profileInputs };
}

export default ComposedCmp =>
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComposedCmp);



// WEBPACK FOOTER //
// ./src/containers/withProfileInputs.jsx